import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiResponse, ApiService } from './api.service';
import { PaymentMethod } from '@models/payment-method.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService {
  private methodsCache = new BehaviorSubject<PaymentMethod[] | undefined>(undefined);

  constructor(
    private apiService: ApiService
  ) { }

  get methods() {
    return this.methodsCache.asObservable();
  }

  get methodsSnapshot() {
    return this.methodsCache.value;
  }

  setMethods(methods: PaymentMethod[] | undefined) {
    this.methodsCache.next(methods);
  }

  addPaymentMethod(method: PaymentMethod) {
    const methods = this.methodsCache.value;
    if (methods && !methods.find((m: PaymentMethod) => m.id === method.id)) {
      methods.unshift(method);
      this.setMethods(methods);
    }
  }

  removePaymentMethod(method: PaymentMethod) {
    const methods = this.methodsCache.value;
    if (methods) {
      this.setMethods(methods.filter((pm: PaymentMethod) => pm.id !== method.id));
    }
  }

  createSetupIntent(token: string): Observable<ApiResponse<any>> {
    return this.apiService.post<ApiResponse<any>>('payment-methods/setup-intent', { payment_method_id: token });
  }

  show(id: string): Observable<ApiResponse<PaymentMethod>> {
    return this.apiService.get<ApiResponse<PaymentMethod>>(`payment-methods/${id}`);
  }

  delete(method: PaymentMethod): Observable<ApiResponse<void>> {
    return this.apiService.delete<ApiResponse<void>>(`payment-methods/${method.id}`).pipe(tap({
      next: (response: ApiResponse<void>) => {
        this.removePaymentMethod(method);
        return response;
      }
    }));
  }
}
